// extracted by mini-css-extract-plugin
export default {"mainWrapper":"styles_mainWrapper__Mm2I6","containerTable":"styles_containerTable__qAKoo","titleTable":"styles_titleTable__tAAf1"};